// extracted by mini-css-extract-plugin
export default {"root":"checkboxNode_root__RugWl"};